import React from 'react';

const InAnalysisAlert = () => (
  <div className="alert alert-warning">
    <strong>Separamos algumas licitações para que você já possa iniciar suas atividades.</strong>
    <br />
    Concluindo a análise de seu cadastro você passará a ter acesso à mais oportunidades.
  </div>
);

export default InAnalysisAlert;
